<template src="./ArrobaMedellinVerticalCardEvents.html"></template>

<script>
import { mapGetters } from "vuex";
import costumeDialog from "@/components/CostumeDialog/CostumeDialog";
import VideoModal from "@/components/VideoModal/VideoModal";
const { DateTime } = require("luxon");
import { roleName } from "@/utils/constants";

export default {
  props: {
    data: { type: Object },
    horizontal: {
      type: Boolean,
      default: false,
      required: false,
    },
    justView: {
      type: Boolean,
      default: false,
      required: false,
    },
    small: {
      type: Boolean,
      default: false,
      required: false,
    },
    eventClosed: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  name: "arroba-medellin-vertical-card-events",
  components: {
    costumeDialog,
    VideoModal,
  },
  data() {
    return {
      buttonText: null,
      disableButton: null,
      buttonDialog: "",
      isCardModalActive: false,
      isCardModalActive1: true,
      role: null,
      roleName,
      isComponentModalActive: false,
      formProps: {
        email: "evan@you.com",
        password: "testing",
      },
    };
  },
  created() {
    this.role = this.user.role.name;
    this.definedText();
  },
  methods: {
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: VideoModal,
        props: {
          data: this.data,
        },
        hasModalCard: true,
        customClass: "custom-class",
        trapFocus: true,
      });
    },
    async pushButton() {
      this.$emit("showEventDetails", this.data);
      if (this.role !== this.roleName.ADMINISTRATOR) {
        const isEventLive =
          !(new Date(this.data.initialHour) - new Date() > 0) &&
          !(new Date(this.data.finalHour) - new Date() < 0);
        const isEventPast = new Date(this.data.finalHour) - new Date() < 0;

        if (this.data.isPublic && isEventLive) {
          this.$store.dispatch("fetchShareAndLoginEvent", {
            show: true,
            data: this.data,
          });
          return;
        }

        if (this.data.isPublic && !this.data.isRegistered && !isEventPast) {
          this.$store.dispatch("fetchShareAndLoginEvent", {
            show: true,
            data: this.data,
          });
          return;
        }

        if (!this.data.isRegistered && !this.data.isPublic) {
          await (this.buttonDialog = "Separa tu cupo");
          this.$refs.dialog.showDialog(this.data, this.buttonDialog);
        } else if (this.data.isFullCapacity && !this.data.isPublic) {
          await (this.buttonDialog = "Aforo lleno");
          this.disableButton = true;
        } else if (this.eventClosed || isEventPast) {
          this.$store.dispatch("fetchWatchAndRate", {
            show: true,
            data: this.data,
          });
        } else if (this.data.isRegistered && isEventLive) {
          this.$store.dispatch("fetchShareAndLoginEvent", {
            show: true,
            data: this.data,
          });
        } else {
          this.$refs.dialog.showDialog(this.data, "Ya tienes un cupo separado");
        }
      }
    },
    definedText() {
      if (this.data.isPublic) {
        const isEventLive =
          !(new Date(this.data.initialHour) - new Date() > 0) &&
          !(new Date(this.data.finalHour) - new Date() < 0);
        const isEventPast = new Date(this.data.finalHour) - new Date() < 0;

        if (isEventLive) {
          this.buttonText = "Ingresar al evento";
          this.disableButton = false;
        } else if (isEventPast) {
          this.buttonText = "Ver información";
        } else {
          this.buttonText = "Ver evento";
          this.disableButton = false;
        }
        return;
      }

      if (
        this.data.isRegistered ||
        this.data.isAvailable ||
        this.user.role.name === "Administrator" ||
        !(new Date(this.data.initialHour) - new Date() > 0)
      ) {
        this.buttonText = "Ver evento";
        this.disableButton = false;
      }

      if (this.data.isFullCapacity) {
        this.buttonText = "Aforo lleno";
        this.disableButton = true;
      }

      if (this.eventClosed) {
        this.buttonText = "Ver información";
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  filters: {
    dateFormat: function (value) {
      return DateTime.fromISO(value).toUTC().toFormat("HH:mm - dd LLLL yyyy", {
        locale: "es",
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./ArrobaMedellinVerticalCardEvents.scss"></style>
